// Module
var code = "<tr data-bind=\"css: { 'disabled': _disabled, 'merge-enabled': _mergedEnabled }\"> <!-- ko foreach: Cells --> <!-- ko template: { html: $data.GetTemplate.bind($data), afterRender: $data.AfterRender.bind($data) } --><!-- /ko --> <!-- /ko --> </tr>";
// Exports
export default code;